import png1 from "./1.jpg";
import png2 from "./2.jpg";
import png3 from "./3.jpg";
import png4 from "./4.jpg";
import png5 from "./5.jpg";
import png6 from "./6.jpg";
export const gpzgyh = [
  {
    name: "查找流水",
    msgList: [
      { msg: "登录中国银行APP->顶部搜索【交易流水打印】" },
      { imgs: [png1, png2, png3] },
    ],
  },
  {
    name: "发送账单",
    msgList: [
      { msg: "选择【近一年时间】，选择【全部收支】->填入专属邮箱->提交申请" },
      { imgs: [png4, png5, png6] },
    ],
  },
  {
    name: "注意事项",
    msgList: [{ msg: "打开【展示交易对方信息和展示完整卡号/账号】" }],
  },
];
